import { Orders } from "@/api/dispatcher";
import { useStore } from "@/store";
import { bus } from "@/eventbus";

const store = useStore();

const INTERVAL = 1 * 60 * 1000;

const EVENT_NOTIFICATION = "notification";

let _timer;

let ordersNotificationSound;
let messagesNotificationSound;

const initSounds = () => {
  const createAudio = (sound) => {
    const audio = document.createElement("audio");
    audio.src = sound;

    document.body.appendChild(audio);

    return audio;
  };

  ordersNotificationSound = createAudio("/sounds/notification_1.mp3");
  messagesNotificationSound = createAudio("/sounds/notification_2.mp3");
};

export default {
  pending: {
    load() {
      let _orders = store.pending_orders.orders;
      let _messages = store.messages;

      return Orders.pending().then((pending_orders) => {
        _orders = _orders.filter((n) => {
          const itemExists = pending_orders.orders.find((item) => {
            if (item.nmbr == n.nmbr) {
              const updated = n.demand_sost != item.demand_sost;
              Object.assign(n, item);
              n.updated = updated;
              if (updated) {
                n.new = false;
              }

              return true;
            }

            return false;
          });

          return itemExists;
        });

        _messages = _messages.filter((n) => {
          const itemExists = pending_orders.messages.find(
            (item) => item.nmbr == n.nmbr
          );

          return itemExists;
        });

        const new_orders = pending_orders.orders.filter((n) => {
          const itemExists = _orders.find((item) => item.nmbr == n.nmbr);
          if (!itemExists) {
            n.new = true;
          }
          return !itemExists;
        });

        const new_messages = pending_orders.messages.filter((n) => {
          const itemExists = _messages.find((item) => item.nmbr == n.nmbr);
          if (!itemExists) {
            n.new = true;
          }
          return !itemExists;
        });

        _orders = _orders.concat(new_orders);
        _messages = _messages.concat(new_messages);

        store.pending_orders.orders = _orders;
        store.pending_orders.params = {
          formname: pending_orders.formname,
          route: pending_orders.route,
          filter: pending_orders.filter,
        };
        store.payed_orders.orders = _orders.filter((o) => o.demand_sost == "1");
        store.payed_orders.params = {
          formname: pending_orders.formname,
          route: pending_orders.route,
          filter: pending_orders.filter,
        };
        store.messages = pending_orders.messages;

        if (new_orders.length || new_messages.length) {
          if (new_orders.length) {
            ordersNotificationSound.play();
          } else if (new_messages.length) {
            messagesNotificationSound.play();
          }
        }

        if (new_orders.length) {
          bus.$emit(EVENT_NOTIFICATION, {
            message: "Поступили новые заявки",
            items: new_orders,
            params: {
              formname: pending_orders.formname,
              route: pending_orders.route,
              filter: pending_orders.filter,
            },
          });
        }

        if (new_messages.length) {
          bus.$emit(EVENT_NOTIFICATION, {
            message: "Поступили новые новые сообщения",
            items: new_messages,
          });
        }
      });
    },
    start() {
      initSounds();
      this.load();
      if (process.env.NODE_ENV === "development") {
        return;
      }

      _timer = setInterval(() => {
        this.load();
      }, INTERVAL);
    },

    stop() {
      clearInterval(_timer);
    },
  },
};
